module.exports = __webpack_public_path__ + "img/nav_social.7bb2c4f6.png";